<template>
  <el-input
    v-model="value"
    type="textarea"
    :rows="8"
    :disabled="disabled"
    @update:modelValue="update"
  />
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'CodeInput',
  props: {
    modelValue: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)

    const update = (newValue: string) => {
      context.emit('update:modelValue', newValue)
    }
    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )
    return { update, value }
  }
})
</script>
